export const PRIVACY_POLICY = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_627';
export const CONSENT_PERSONAL_DATA =
  'https://cdn.cian.site/frontend/info-assets/cpd/soglasheniye_po_obrabotke_addform_2_2025.pdf';
